import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Column,
  DataGrid,
  Selection,
  Button,
  SearchPanel,
} from "devextreme-react/data-grid";
import Grid from "@material-ui/core/Grid";
import Guid from "devextreme/core/guid";
import TextField from "@material-ui/core/TextField";
import MUIRichTextEditor from "mui-rte";
import { stateToHTML } from "draft-js-export-html";
import ReactHtmlParser from "react-html-parser";
import { convertFromHTML, ContentState, convertToRaw } from "draft-js";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import swal from "sweetalert";
import Button1 from "@material-ui/core/Button";
import axios from "axios";
import { createStore } from "devextreme-aspnet-data-nojquery";
import Container from "@material-ui/core/Container";
import { useSearchParams } from "react-router-dom";
import RadioButton from "../RadioButton2.jsx";
import { api_path } from "../../shared.js";
const url_customer = api_path + "/CUSTOMER_CONTACT.php";
const url_contact = api_path + "/CC_CONTACT.php";
export function BookingConfirmationForm(props) {
  const [searchParams] = useSearchParams();
  const DOCNO = searchParams.get("doc");
  const ORDER_ID = searchParams.get("order_id");
  const ITEM_ID = searchParams.get("item_id");
  const shipper = searchParams.get("shpr");
  const cnee = searchParams.get("cnee");
  const view = searchParams.get("view");
  const [GET_USER_ID, SET_USER_ID] = useState("");
  const [GET_ADD_EMAIL, SET_ADD_EMAIL] = useState("");
  const [GET_SUBJECT_MAIL, SET_SUBJECT_MAIL] = useState("");
  const [GET_TO_MAIL, SET_TO_MAIL] = useState("");
  const [GET_CC_MAIL, SET_CC_MAIL] = useState("");
  const [GET_BODY_MAIL, SET_BODY_MAIL] = useState("");
  const [GET_CUSTOMER_CODE, SET_CUSTOMER_CODE] = useState("");
  const [GET_ORDER_NO, SET_ORDER_NO] = useState("");
  const [GET_BOOKING_NO, SET_BOOKING_NO] = useState("");
  const [GET_BSE_NO, SET_BSE_NO] = useState("");
  const [GET_SALES_EMAIL, SET_SALES_EMAIL] = useState("");
  const [GET_SALES_ID, SET_SALES_ID] = useState("");
  const [GET_SHIPPER_CODE, SET_SHIPPER_CODE] = useState("");
  const [GET_CONSIGNEE, SET_CONSIGNEE] = useState("");
  const [GET_CONSIGNEE_CODE, SET_CONSIGNEE_CODE] = useState("");

  const [GET_SHIPREM, SET_SHIPREM] = useState("");
  const [GET_REMARK1, SET_REMARK1] = useState("");
  const [GET_REMARK2, SET_REMARK2] = useState("");
  const [GET_REMARK3, SET_REMARK3] = useState("");
  const [GET_CONTENT, SET_CONTENT] = useState("");

  const [GET_SIG_NAME, SET_SIG_NAME] = useState("");
  const [GET_SIG_POSITION, SET_SIG_POSITION] = useState("");
  const [GET_SIG_TEL, SET_SIG_TEL] = useState("");

  const [showAddBtn, setShowAddBtn] = useState(true);
  const [GET_CUSTOMER_TYPE, SET_CUSTOMER_TYPE] = useState("");
  const [getLoadGrid, setLoadGrid] = useState();
  const [getCrmId, setCrmId] = useState(props.CRM_ID);
  const [getUserRole, setUserRole] = useState(props.USER_ROLE);
  const [getUserID, setUserID] = useState(props.USER_EMAIL);
  const [getEmpCode, setEmpCode] = useState(props.EMP_CODE);
  const [GET_BOOKING_FILENAME, SET_BOOKING_FILENAME] = useState("");
  useEffect(() => {
    fetchData(DOCNO);
  });
  useEffect(() => {
    let sampleMarkup;
    SET_CUSTOMER_CODE(shipper);
    if (DOCNO) {
      fetch(
        api_path +
          "/SalesOrderConfirmBookingDetail.php?DOCNO=" +
          DOCNO +
          "&view=" +
          view
      )
        .then((res) => res.json())
        .then((res) => {
          const array = res;
          for (const i of array) {
            let PO_STR;
            let INV_STR;
            let FINAL_STR;
            if (
              i.ORDERNO === "" ||
              i.ORDERNO === null ||
              i.ORDERNO === undefined
            ) {
              if (
                i.OPTION10 === "" ||
                i.OPTION10 === null ||
                i.OPTION10 === undefined
              ) {
                PO_STR = "";
              } else {
                PO_STR = " INV No." + i.OPTION10;
              }
            } else {
              PO_STR = " PO NO. " + i.ORDERNO + "";
            }

            if (i.FINAL !== "" || i.FINAL !== null || i.FINAL !== undefined) {
              if (i.FINAL === "" || i.FINAL === null || i.FINAL === undefined) {
                FINAL_STR = i.DEL;
              } else {
                FINAL_STR = i.FINAL;
              }
            } else {
              FINAL_STR = "";
            }
            SET_SUBJECT_MAIL(
              "SINO BKG CFM NO: " +
                i.BOOKNO +
                "/FINAL DESTINATION:" +
                FINAL_STR +
                " /ETD: " +
                i.ETD +
                " /S: " +
                i.SHIPPERNAME +
                "" +
                PO_STR +
                " /C: " +
                i.CONSIGNEENAME +
                ""
            );
            let res;
            let res2;

            if (i.ETD) {
              res = i.ETD.replace(/[^a-zA-Z0-9]/g, "");
            } else {
              res = "";
            }
            if (i.POD) {
              res2 = i.POD.replace(/[^a-zA-Z0-9]/g, "");
            } else {
              res2 = "";
            }
            let getPdfFilename =
              "BOOKING_CONFIRMATION_NO_" +
              i.BOOKNO +
              "_ETD_" +
              res +
              "_FINAL_DESTINATION_" +
              FINAL_STR.replace(/[^a-zA-Z0-9]/g, "") +
              ".pdf";
            SET_BOOKING_FILENAME(getPdfFilename.replaceAll("/", "-"));
            SET_BSE_NO(i.DOCNO);
            SET_BOOKING_NO(i.BOOKNO);
            SET_REMARK1(i.REMARK3_1);
            SET_REMARK2(i.REMARK3_2);
            SET_REMARK3(i.REMARK3_3);
            sampleMarkup =
              "<b>Dear Value Customer,</b><br/ ><br />Thank you for choosing our services.<br />";
            sampleMarkup +=
              "Please see attached Booking Confirmation of your shipment.";

            if (
              i.REMARK3_1 !== "" &&
              i.REMARK3_1 !== null &&
              i.REMARK3_1 !== undefined
            ) {
              sampleMarkup +=
                "<br/><br/><b>Special Remark</b><br/>" +
                i.REMARK3_1 +
                "<br/>" +
                i.REMARK3_2 +
                "<br/>" +
                i.REMARK3_3 +
                "";
            }
            if (
              i.SHIPREM_2 !== "" &&
              i.SHIPREM_2 !== null &&
              i.SHIPREM_2 !== undefined
            ) {
              sampleMarkup +=
                "<br/><br/><b>Last date for return all container(s) to avoid GRI charge :</b><br/>" +
                i.SHIPREM_2 +
                "";
            }
            sampleMarkup +=
              "<br />Should you require any further assistance, please feel free to contact us. Thank you.<br/ ><br />";
            sampleMarkup += "<b>Best Regards,</b><br />";
            sampleMarkup +=
              "<b>SINO LOGISTICS CORPORATION PUBLIC COMPANY LIMITED</b>";
            let contentHTML;
            //1. Convert the HTML
            contentHTML = convertFromHTML(sampleMarkup);
            // 2. Create the ContentState object
            let state;
            state = ContentState.createFromBlockArray(
              contentHTML.contentBlocks,
              contentHTML.entityMap
            );
            // 3. Stringify `state` object from a Draft.Model.Encoding.RawDraftContentState object
            SET_CONTENT(JSON.stringify(convertToRaw(state)));
          }
        });
    }
  }, []);
  function fetchData(docno) {
    fetch(api_path + "/SalesOrderGetDetailByDocno.php?DOCNO=" + docno)
      .then((res) => res.json())
      .then((res) => {
        const array = res;
        for (const i of array) {
          SET_SALES_ID(i.SALES_ID);
          SET_SALES_EMAIL(i.SALES_EMAIL);
          SET_ORDER_NO(i.ORDER_NO);
        }
      });
  }

  const dataSourceCustomerEmail = createStore({
    key: "CUSTOMER_CONTACT_ID",
    loadUrl: `${url_customer}`,
    loadParams: { CUSTOMER_CODE: GET_CUSTOMER_CODE },
  });
  const dataSourceCC_Contact = createStore({
    key: "CUSTOMER_CONTACT_ID",
    loadUrl: `${url_contact}`,
    loadParams: { SALES_ID: GET_SALES_ID, CUSTOMER_CODE: GET_CUSTOMER_CODE },
  });

  const dataGridRef = useRef(null);
  const getEmployeeName = (row) => `${row.CUSTOMER_EMAIL}`;
  const getEmployeeNames = (selectedRowsData) =>
    selectedRowsData.length
      ? selectedRowsData.map(getEmployeeName).join(", ")
      : "";
  const [prefix, setPrefix] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedEmployeeNames, setSelectedEmployeeNames] = useState("");
  const onSelectionChanged = useCallback(
    ({ selectedRowKeys: changedRowKeys, selectedRowsData }) => {
      setPrefix(null);
      setSelectedRowKeys(changedRowKeys);
      setSelectedEmployeeNames(getEmployeeNames(selectedRowsData));
      SET_TO_MAIL(getEmployeeNames(selectedRowsData));
    },
    []
  );
  /////////////////////////////////////////////////////
  const dataGridRef2 = useRef(null);
  const getContactName = (row) => `${row.CUSTOMER_EMAIL}`;
  //const getEmployeeName = (row) => `${row.CUSTOMER_EMAIL} ${row.CUSTOMER_EMAIL}`;
  const getContactNames = (selectedRowsData) =>
    selectedRowsData.length
      ? selectedRowsData.map(getContactName).join(", ")
      : "";
  //const [prefix, setPrefix] = useState("");
  const [selectedRowKeysContact, setSelectedRowKeysContact] = useState([]);
  const [selectedContactNames, setSelectedContactNames] = useState("");

  const onSelectionContactChanged = useCallback(
    ({ selectedRowKeys: changedRowKeys, selectedRowsData }) => {
      setPrefix(null);
      setSelectedRowKeysContact(changedRowKeys);
      setSelectedContactNames(getContactNames(selectedRowsData));
      SET_CC_MAIL(getContactNames(selectedRowsData));
    },
    []
  );
  const onClearButtonClicked = useCallback(() => {
    dataGridRef.current.instance().clearSelection();
  }, []);

  // const onSelectionFilterChanged = useCallback(({ value }) => {
  //   const newPrefix = value;
  //   if (newPrefix) {
  //     const filteredEmployees = newPrefix === 'All'
  //       ? employees
  //       : employees.filter((employee) => employee.Prefix === newPrefix);
  //     const changedRowKeys = filteredEmployees.map((employee) => employee.ID);
  //     setPrefix(newPrefix);
  //     setSelectedRowKeys(changedRowKeys);
  //     setSelectedEmployeeNames(getEmployeeNames(filteredEmployees));
  //   }
  // }, []);
  const [errors, setErrors] = useState({});
  const validateForm3 = () => {
    const errors = {};
    if (!GET_TO_MAIL) {
      errors.ToMail = "Required";
    }
    if (!GET_SUBJECT_MAIL) {
      errors.SubjectMail = "Required";
    }
    return errors;
  };
  const handleSubmitcccc = (event) => {
    // const fileStr = Files.map((data) => data.filename).join(",");
    // let filesName;
    // filesName = fileStr.replaceAll(" ", "_")
    // alert(filesName)
    if (selectedfile.length > 0) {
      const fileStr = selectedfile.map((data) => data.filename).join(",");
      let filesName;
      filesName = fileStr.replaceAll(" ", "_");
      //alert(filesName);
      // for (let index = 0; index < selectedfile.length; index++) {
      //     SetFiles((preValue)=>{
      //         return[
      //             ...preValue,
      //             selectedfile[index]
      //         ]
      //     })
      // }
      // SetSelectedFile([]);
    } else {
      //alert("Please select file");
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const newErrors = validateForm3();
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      //alert("Invalid")
    } else {
      swal({
        title: "Are you sure?",
        text: "to send email confirmation.",
        icon: "info",
        dangerMode: false,
        buttons: true,
      }).then((isConfirm) => {
        if (isConfirm) {
          ////////////////////////////

          let filesName;
          if (selectedfile.length > 0) {
            const fileStr = selectedfile.map((data) => data.filename).join(",");
            filesName = fileStr.replaceAll(" ", "_");
            //alert(filesName)
          } else {
            filesName = "";
            //alert('Please select file')
          }
          // if (files.length === 0) {
          //   filesName = "";
          // } else {
          //filesName = getFileName;
          //}

          var data = {
            MAIL_TO: GET_TO_MAIL,
            MAIL_CC: GET_CC_MAIL,
            MAIL_SUBJECT: GET_SUBJECT_MAIL,
            MAIL_BODY: GET_BODY_MAIL,
            BOOKING_ATTACHMENT: GET_BOOKING_FILENAME,
            OTHER_ATTACHMENT: filesName,
            ORDER_ID: ORDER_ID,
            SALES_ORDER_ITEM_ID: ITEM_ID,
            USERID: getCrmId,
            REMARK: "BSE Confirmed",
          };
          fetch(api_path + "/SALES_ORDER_UpdateSalesOrderConfirmCustomer.php", {
            method: "POST",
            headers: {
              Accept: "application/form-data",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((res) => res.json())
            .then((result) => {
              if (result["status"] == "200") {
                swal("Done.", "Save data successfully.", "success", {
                  buttons: true,
                  timer: 5000,
                }).then(function () {
                  const url =
                    api_path +
                    "/SENDMAIL_SALESORDER.php?order_id=" +
                    ORDER_ID +
                    "&flag=bookingconfirmation&order_status=10";
                  axios
                    .get(url)
                    .then((response) => {
                      // handle success
                      console.log(result["message"]);
                    })
                    .then((data) => {
                      console.log(data);
                      // Handle data
                    })
                    .catch((error) => {
                      // handle errors
                    });

                  ////////////////////////////////////////////////////
                  window.location = "./JobManagment";
                });
              } else {
                //setButtonDisabled(false);
                swal("Sorry", result["message"], "error", {
                  buttons: true,
                  timer: 5000,
                });
              }
            });

          ////////////////////////////////
        }
      });
    }
  };
  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
    }
  };
  const isCheckedRadioStatus = (value) => radioStatus === value;
  const [radioStatus, setRadioStatus] = useState("SHIPPER");
  const handleRadioChange = (event) => {
    setRadioStatus(event.target.value);
    if (event.target.value == "SALES") {
      SET_TO_MAIL(GET_SALES_EMAIL);
      SET_CUSTOMER_TYPE("SALES");
      SET_CUSTOMER_CODE("");
      setShowAddBtn(false);
      //SET_CC_MAIL(GET_SALES_EMAIL);
    } else if (event.target.value == "SHIPPER") {
      //SET_TO_MAIL("");
      SET_CUSTOMER_TYPE("SHIPPER");
      SET_CUSTOMER_CODE(shipper);
      setShowAddBtn(true);
      //alert(shipper)
      //SET_CC_MAIL(GET_SALES_EMAIL);
    } else if (event.target.value == "CNEE") {
      //SET_TO_MAIL("");
      setShowAddBtn(true);
      SET_CUSTOMER_TYPE("CNEE");
      SET_CUSTOMER_CODE(cnee);
      //SET_CC_MAIL(GET_SALES_EMAIL);
    }
  };
  const [initialData, setInitialData] = useState("");
  let options = {
    entityStyleFn: (entity) => {
      const entityType = entity.get("type").toLowerCase();
      if (entityType === "image") {
        const data = entity.getData();
        return {
          element: "img",
          attributes: {
            src: data.src,
          },
          style: {
            // Put styles here...
          },
        };
      }
    },
  };

  const getData = () => {
    console.log("Initial data ", initialData);
  };

  const getHTMLData = (value) => {
    stateToHTML(value.getCurrentContent());
    setInitialData(stateToHTML(value.getCurrentContent()));
    SET_BODY_MAIL(stateToHTML(value.getCurrentContent()));
  };
  const myTheme = createTheme({
    overrides: {
      MUIRichTextEditor: {
        root: {
          backgroundColor: "#ebebeb",
        },
        container: {
          display: "flex",
          flexDirection: "column-reverse",
        },
        editor: {
          backgroundColor: "#ebebeb",
          paddingLeft: 5,
        },
        toolbar: {
          borderTop: "1px solid gray",
          backgroundColor: "#ebebeb",
        },
        placeHolder: {
          backgroundColor: "#ebebeb",
          paddingLeft: 5,
          width: "inherit",
          height: " 100px",
          maxHeight: "100px",
        },
        anchorLink: {
          color: "#333333",
          textDecoration: "underline",
        },
      },
    },
  });
  const [showUploadMsg, setShowUploadMsg] = useState(
    "Choose file before Pressing the Upload button."
  );
  const [errorMessage, setErrorMessage] = useState("");
  function checkIsAllowedType(selectedFiles) {
    const allowedTypes = [
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".pdf",
      ".doc",
      ".docx",
      ".xls",
      ".xlsx",
      ".csv",
    ];
    return selectedFiles.some((file) => {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      return allowedTypes.includes(`.${fileExtension}`);
    });
  }

  function validateFileOnChange(formFileData) {
    const allowedTypes = ["image/jpeg", "image/png", "image/gif"];
    const maxSize = 2 * 1024 * 1024; // 2MB

    let validFiles = [];

    formFileData.forEach((file) => {
      if (allowedTypes.includes(file.type) && file.size <= maxSize) {
        validFiles.push(file);
      }
    });

    return validFiles;
  }

  function readableBytes(bytes) {
    var i = Math.floor(Math.log(bytes) / Math.log(1024)),
      sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    return (bytes / Math.pow(1024, 2)).toFixed(2) * 1 + " " + sizes[2];
  }
  const [getAttachment, setAttachment] = useState("");
  const splitedStr = getAttachment.split(",");
  var returnStr = "";
  for (var i = 0; i < splitedStr.length; i++) {
    returnStr +=
      '<p><a href="https://apps.sinologistics.co.th/api/uploads/sales_confirm_local/' +
      splitedStr[i] +
      '" target="_blank">' +
      splitedStr[i] +
      "</a></p>";
  }
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  const validateForm2 = () => {
    const errors = {};
    if (!GET_ADD_EMAIL) {
      errors.ADDEMAILERR = "Please fill email address";
    }
    let emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;
    const regexp =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!regexp.test(GET_ADD_EMAIL)) {
      //if (!emailRegex.test(GET_ADD_EMAIL)) {
      errors.ADDEMAILERR = "Error! you have entered invalid email.";
    }
    return errors;
  };
  function onAddEmailButtonClick() {
    const newErrors = validateForm2();
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      //alert("Invalid")
    } else {
      swal({
        title: "Are you sure?",
        text: "Add email contact.",
        icon: "info",
        dangerMode: false,
        buttons: true,
      }).then((isConfirm) => {
        if (isConfirm) {
          var data = {
            CUSTOMER_PARENT_CODE: GET_CUSTOMER_CODE,
            CUSTOMER_EMAIL: GET_ADD_EMAIL,
            CONTACT_NAME: "",
            UPDATE_BY: getCrmId,
          };
          fetch(api_path + "/TS_CUSTOMER_CONTACT.php", {
            method: "POST",
            headers: {
              Accept: "application/form-data",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((res) => res.json())
            .then((result) => {
              if (result["status"] == "200") {
                console.log("ok");
                swal("Done.", "Save data successfully.", "success", {
                  buttons: true,
                  timer: 5000,
                }).then(function () {
                  setLoadGrid(randomNumberInRange(1, 20));
                });
              } else {
                console.log("no");
                swal("Sorry", result["message"], "error", {
                  buttons: true,
                  timer: 5000,
                });
              }
            });
        } //end check valid data
      });
    }
  }

  const onDeleteButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    swal({
      title: "Are you sure to delete = " + dataRow.CUSTOMER_EMAIL,
      text: "",
      icon: "info",
      dangerMode: false,
      buttons: true,
    }).then((isConfirm) => {
      if (isConfirm) {
        delContact(e.row.key);
      }
    });
  }, []);
  const delContact = async (id) => {
    try {
      const response = await axios.delete(
        api_path + `/SALES_ORDER_UpdateSalesOrderConfirmCustomer.php?id=${id}`
      );
      setLoadGrid(randomNumberInRange(1, 20));
    } catch (error) {
      console.error(error);
    }
  };
  const [files, setFiles] = useState([]);
  const [getFileName, setFileName] = useState([]);
  const [selectedfile, SetSelectedFile] = useState([]);
  const [Files, SetFiles] = useState([]);
  const filesizes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };
  const InputChange = (e) => {
    setShowUploadMsg("⚠️ Pressing the Upload button.");
    const selectedFiles = Array.from(e.target.files);
    // const selectedFiles = Array.from(e.target.files);
    console.log(e.target.files);
    //setSelectedFiles(Array.from(e.target.files));
    var totalSize = 0;
    for (let i = 0; i < e.target.files.length; i++) {
      const file = selectedFiles[i];
      SetSelectedFile((preValue) => {
        return [
          ...preValue,
          {
            id: i,
            filename: e.target.files[i].name,
            filetype: e.target.files[i].type,
            filesize: filesizes(e.target.files[i].size),
          },
        ];
      });
      if (file) {
        totalSize += parseInt(file.size);
      }
    }
    const maxSize = 30 * 1024 * 1024; // 30MB
    console.log("max size:" + maxSize);
       console.log("Total file size:" + totalSize);
    if (totalSize > maxSize) {
      console.log("File size exceeds. It should be less than 30MB");
      setErrorMessage("File size exceeds. It should be less than 30MB.");
      setShowUploadMsg("");
    } else {
      const isAllowedFiles = checkIsAllowedType(selectedFiles);
      if (!isAllowedFiles) {
        setErrorMessage(
          "Please select file jpg, jpeg, png, gif, pdf, doc ,docx, xls, xlsx, csv ."
        );
        setShowUploadMsg("");
      } else {
        setErrorMessage("");

        const commaString = selectedFiles.map((item) => item.name).join(",");
        setFileName(commaString.replaceAll(" ", "_"));
        setFiles(selectedFiles);
      }
    }
  };
  const handleFileUpload = async () => {
    if (files.length === 0) {
      setErrorMessage("Please select atleast a file to upload.");
      setShowUploadMsg("");
      return;
    }
    setErrorMessage("");
    //console.log("files ..." + files);
    handleMultipleFileUploadAjax(files);
  };
  async function handleMultipleFileUploadAjax(
    files,
    setUploadProgress,
    setErrorMessage
  ) {
    try {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      formData.append("dirname", DOCNO);
      const response = await axios.post(
        api_path + "/CF_SALEORDER_UPLOAD.php",
        formData,
        {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
          },
        }
      );
      if (response.data.status == "200") {
        setShowUploadMsg("✅ Uploaded successfully!");
      } else {
        setShowUploadMsg("❌ Upload failed! " + response.data.message);
      }
    } catch (error) {
      setShowUploadMsg("❌ Upload failed!");
      console.error(error);
    }
  }
  const DeleteSelectFile = (id, index) => {
    if (window.confirm("Are you sure you want to delete this file?")) {
      const result = selectedfile.filter((data) => data.id !== id);
      SetSelectedFile(result);
      // setFiles(
      //   selectedFiles.filter((data) => data.id !== id)
      // );
    } else {
      alert("Can not delete this file");
    }
  };
  const DeleteFile = async (id, index) => {
    if (window.confirm("Are you sure you want to delete this file?")) {
      const result = Files.filter((data) => data.id !== id);
      SetFiles(result);
    } else {
      alert("Can not delete file.");
    }
  };

  return (
    <Container maxWidth="md" className="BorderBox">
      <form
        onSubmit={handleSubmit}
        onKeyDown={(e) => {
          handleKeyDown(e, handleSubmit);
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}></Grid>
          <Grid item xs={12} sm={3}>
            <label>
              BSE No: &nbsp;
              <TextField
                size="small"
                name="GET_BSE_NO"
                variant="outlined"
                id="GET_BSE_NO"
                value={GET_BSE_NO}
                onChange={(e) => SET_BSE_NO(e.target.value)}
                disabled="true"
              />{" "}
            </label>
            {errors.bse && <span className="error-message">{errors.bse}</span>}
          </Grid>
          <Grid item xs={12} sm={3}>
            <label>
              ORDER No:&nbsp;
              <TextField
                size="small"
                name="GET_ORDER_NO"
                variant="outlined"
                id="GET_ORDER_NO"
                value={GET_ORDER_NO}
                onChange={(e) => SET_ORDER_NO(e.target.value)}
                disabled="true"
              />
            </label>
          </Grid>
          <Grid item xs={12} sm={3}>
            <label>
              Book No:&nbsp;
              <TextField
                size="small"
                name="GET_BOOKING_NO"
                variant="outlined"
                id="GET_BOOKING_NO"
                value={GET_BOOKING_NO}
                onChange={(e) => SET_BOOKING_NO(e.target.value)}
                disabled="true"
              />
            </label>
          </Grid>
          <Grid item xs={12} sm={3}></Grid>
          <Grid item xs={12} sm={3}>
            <RadioButton
              id="SALES"
              name="SALES"
              value="SALES"
              text="SALES"
              onChange={handleRadioChange}
              checked={isCheckedRadioStatus("SALES")}
            />
            <br />
            <div className="dd">Pre-Confirmation</div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <RadioButton
              id="SHIPPER"
              name="SHIPPER"
              value="SHIPPER"
              text="SHIPPER"
              onChange={handleRadioChange}
              checked={isCheckedRadioStatus("SHIPPER")}
            />
            <br /> <div className="dd">Confirmation</div>
            {GET_SHIPPER_CODE}
          </Grid>
          <Grid item xs={12} sm={3}>
            <RadioButton
              id="CNEE"
              name="CNEE"
              value="CNEE"
              text="CNEE"
              onChange={handleRadioChange}
              checked={isCheckedRadioStatus("CNEE")}
            />
            <br />
            <div className="dd">Confirmation</div>
            {GET_CONSIGNEE_CODE}
          </Grid>
          <Grid item xs={12} sm={3}></Grid>
          <Grid item xs={12} sm={12}>
            <label>To: </label>
            <TextField
              size="small"
              name="GET_TO_MAIL"
              variant="standard"
              fullWidth
              id="GET_TO_MAIL"
              value={GET_TO_MAIL}
              onChange={(e) => SET_TO_MAIL(e.target.value)}
            />

            {errors.ToMail && (
              <span className="error-message">{errors.ToMail}</span>
            )}
          </Grid>
          <Grid item xs={12} sm={8}>
            {/* <div className="selected-data">
              <span className="caption">Selected Records:</span>{" "}
              <span>{selectedEmployeeNames}</span>
            </div> */}
            <DataGrid
              dataSource={dataSourceCustomerEmail}
              showBorders={false}
              keyExpr="CUSTOMER_CONTACT_ID"
              onSelectionChanged={onSelectionChanged}
              ref={dataGridRef}
              selectedRowKeys={selectedRowKeys}
            >
              <Selection mode="multiple" />
              <SearchPanel
                visible={true}
                width={240}
                placeholder="Full Text Search..."
              />
              <Column
                dataField="CUSTOMER_EMAIL"
                caption="SELECT EMAIL"
                width="90%"
              />
              <Column dataField="CONTACT_NAME" caption="NAME" width="30%" />
              <Column type="buttons">
                <Button
                  icon="trash"
                  onClick={onDeleteButtonClick}
                  hint="Delete"
                />
              </Column>
            </DataGrid>
          </Grid>
          <Grid item xs={12} sm={4}>
            {" "}
          </Grid>
          {showAddBtn && (
            <Grid item xs={12} sm={6}>
              <label>Add: </label>
              <TextField
                size="small"
                name="GET_ADD_EMAIL"
                variant="outlined"
                fullWidth
                id="GET_ADD_EMAIL"
                type="email"
                value={GET_ADD_EMAIL}
                onChange={(e) => SET_ADD_EMAIL(e.target.value)}
              />
              {errors.ADDEMAILERR && (
                <span className="error-message">{errors.ADDEMAILERR}</span>
              )}
            </Grid>
          )}
          {showAddBtn && (
            <Grid
              item
              xs={12}
              sm={6}
              style={{ display: "flex", marginTop: "20px" }}
            >
              <br />{" "}
              <button
                className="btn btn-primary"
                form="editmodal"
                onClick={onAddEmailButtonClick}
              >
                +
              </button>
            </Grid>
          )}
          <Grid item xs={12} sm={12}>
            <label>CC: </label>
            <TextField
              size="small"
              name="GET_CC_MAIL"
              variant="standard"
              fullWidth
              id="GET_CC_MAIL"
              value={GET_CC_MAIL}
              onChange={(e) => SET_CC_MAIL(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={8}>
            <DataGrid
              dataSource={dataSourceCC_Contact}
              showBorders={false}
              keyExpr="CUSTOMER_CONTACT_ID"
              onSelectionChanged={onSelectionContactChanged}
              ref={dataGridRef2}
              selectedRowKeys={selectedRowKeysContact}
            >
              <Selection mode="multiple" />
              <SearchPanel
                visible={true}
                width={240}
                placeholder="Full Text Search..."
              />
              <Column
                dataField="CUSTOMER_EMAIL"
                caption="SELECT EMAIL"
                width="50%"
              />
              <Column dataField="CONTACT_NAME" caption="NAME" width="30%" />
            </DataGrid>
          </Grid>
          <Grid item xs={12} sm={4}>
            {" "}
          </Grid>
          <Grid item xs={12} sm={12}>
            <label>Subject: </label>
            <TextField
              size="small"
              name="GET_SUBJECT_MAIL"
              variant="standard"
              fullWidth
              id="GET_SUBJECT_MAIL"
              value={GET_SUBJECT_MAIL}
              onChange={(e) => SET_SUBJECT_MAIL(e.target.value)}
            />
            {errors.SubjectMail && (
              <span className="error-message">{errors.SubjectMail}</span>
            )}
          </Grid>

          <Grid item xs={12} sm={12}>
            <label>Body: </label>
            <ThemeProvider theme={myTheme}>
              <MUIRichTextEditor
                label="Body..."
                inlineToolbar={true}
                controls={[
                  "title",
                  "bold",
                  "italic",
                  "underline",
                  "highlight",
                  "link",
                  "numberList",
                  "bulletList",
                ]}
                defaultValue={GET_CONTENT}
                onChange={(value) => getHTMLData(value)}
              />
            </ThemeProvider>
          </Grid>
          <Grid item xs={12} sm={12}>
            {/* <a href={`http://localhost:8081/sinoapi/crm/uploads/sales_confirm_local/${GET_BOOKING_FILENAME}`} target="_blank">  */}
            <a
              href={`https://apps.sinologistics.co.th/api/uploads/sales_confirm_local/${GET_BOOKING_FILENAME}`}
              target="_blank"
              className="linkurl"
            >
              Click to preview confirm booking file
            </a>
            <br />
            <br />
            <label>Attach another file</label>
            <div className="kb-file-upload">
              <div className="file-upload-box">
                <input
                  type="file"
                  id="fileupload"
                  className="file-upload-input"
                  onChange={InputChange}
                  multiple
                />
                <span>
                  Drag and drop or{" "}
                  <span className="file-link">Choose your files</span>
                </span>
              </div>
            </div>
            <div className="kb-attach-box mb-3">
              {selectedfile.map((data, index) => {
                const { id, filename, filesize } = data;
                return (
                  <div className="file-atc-box" key={id}>
                    <div className="file-detail">
                      <h6>{filename}</h6>
                      <p>
                        <span>Size : {filesize}</span>
                      </p>
                      <div className="file-actions">
                        <button
                          type="button"
                          className="file-action-btn"
                          onClick={() => DeleteSelectFile(id, index)}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            {Files.length > 0 ? (
              <div className="kb-attach-box">
                <hr />
                {Files.map((data, index) => {
                  const { id, filename, filesize } = data;
                  return (
                    <div className="file-atc-box" key={index}>
                      <div className="file-detail">
                        <h6>{filename}</h6>
                        <p>
                          <span>Size : {filesize}</span>
                        </p>
                        <div className="file-actions">
                          <button
                            className="file-action-btn"
                            onClick={() => DeleteFile(id, index)}
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              ""
            )}
            {files && (
              <Button1
                type="button"
                variant="outlined"
                color="primary"
                onClick={handleFileUpload}
              >
                &uarr; Click to Upload {files.length > 1 ? "files" : " file"}
              </Button1>
            )}
            &nbsp; &nbsp; &nbsp;
            <label>{showUploadMsg}</label>
          </Grid>
          {errorMessage && (
            <Grid item xs={12} sm={12}>
              <label className="red">{errorMessage}</label>
            </Grid>
          )}
          {getAttachment && (
            <Grid item xs={12} sm={12}>
              <label>File:</label>
              <p className="data">{ReactHtmlParser(returnStr)}</p>
            </Grid>
          )}
          <Grid item xs={12} sm={6}></Grid>
          <Grid item xs={12} sm={6}>
            <Button1
              // disabled={!isButtonDisabled}
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
            >
              Send Email
            </Button1>
          </Grid>
    
        </Grid>
      </form>
    </Container>
  );
}
